import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import SecondaryTabbedComponent from '../../shared/components/layout/SecondaryTabbedComponent';
import IndependentPaymentStages from '../components/layout/IndependentPaymentStages';
import GroupPaymentStages from '../components/layout/GroupPaymentStages';
import PaymentTemplates from '../components/layout/PaymentTemplates';

const AccountsPaymentStagesDetails = ({ projectId: propProjectId }) => {
    const userId = Cookies.get('userId');
    const { id: urlProjectId } = useParams();
    const projectId = propProjectId || urlProjectId;
    const [activeTab, setActiveTab] = useState('Independent');
    const { collapsed } = useSidebar();

    // Track page view
    useEffect(() => {
        mixpanel.track('Accounts Payment Stages Details Viewed', {
            user_id: userId,
            timestamp: new Date().toISOString()
        });
    }, [userId]);

    const handleTabChange = (tabName) => {
        setActiveTab(tabName);
    };

    // Tab metadata
    const tabbedComponentMetaData = {
        tabs: ['Independent', 'Group', 'Templates']
    };

    return (
        <div
            className={`transition-all duration-300 ease-in-out w-full flex flex-col pl-5 pr-5 bg-gray-100 overflow-hidden`}>
            {/* Tabs */}
            <div className="mt-6 mb-4">
                <SecondaryTabbedComponent
                    data={tabbedComponentMetaData}
                    activePrimary={activeTab}
                    onChangePrimaryTab={handleTabChange}
                    rounded={true}
                />
            </div>

            {/* Content based on active tab */}
            <div className="mt-6">
                {activeTab === 'Independent' ? (
                    <IndependentPaymentStages projectId={projectId} hideAddButton={true} showActions={false} />
                ) : activeTab === 'Group' ? (
                    <GroupPaymentStages projectId={projectId} hideAddButton={true} showActions={false} />
                ) : (
                    <PaymentTemplates projectId={projectId} hideAddButton={true} showActions={false} />
                )}
            </div>
        </div>
    );
};

export default AccountsPaymentStagesDetails;
